const zh = {
  i18n: {
    login: '登录',
    account: '账号',
    connectWallet: '连接钱包',
    designBy: '设计者',
    price: '价格',
    totalMinted: '已铸造数量',
    endTime: '结束时间',
    mint: '铸造',
    ended: '已结束',
    view: '查看',
    tips: '*所有信息仅供参考。Transit不提供任何投资建议。本次活动中NFT均遵循',
    cc0: 'CC0协议',
    searchName: '搜索名字或ID'
  }
};

export default zh;